module.exports = __webpack_public_path__ + "static/media/gavel.2602e436.svg";